import { addMinutes, formatISO } from 'date-fns';
import { appListener } from '../../../setup/store/listener.middlerware';
import { RootState } from '../../../setup/store/store';
import { SuccessfulCheckIn } from '../models/public-token.model';
import { publicTokenEndpoints } from './public-token.endpoints';
import { publicTokenLocal } from './public-token.local-storage';
import { clearPublicCheckInSuccessfulIds, setActiveSuccessful, setPublicCheckInValue } from './public-token.slice';

appListener.startListening({
    matcher: publicTokenEndpoints.endpoints.publicToken.matchFulfilled,
    effect: (action, listenerApi) => {
        const state = listenerApi.getState() as RootState;

        const exists = state.publicToken.all.find(x => x.sessionId === action.payload.eventSession?.id);
        if (exists) {
            listenerApi.dispatch(setActiveSuccessful(exists));
        }
    },
});

appListener.startListening({
    matcher: publicTokenEndpoints.endpoints.publicCheckIn.matchFulfilled,
    effect: (action, listenerApi) => {
        const args = action.meta.arg.originalArgs;
        if (!args.remember) {
            return;
        }

        listenerApi.dispatch(setPublicCheckInValue({ value: args.value }));
        publicTokenLocal.saveValue(args.value);
    },
});

appListener.startListening({
    matcher: publicTokenEndpoints.endpoints.publicCheckIn.matchFulfilled,
    effect: (action, listenerApi) => {
        const state = listenerApi.getState() as RootState;
        const args = action.meta.arg.originalArgs;
        const getResponse = publicTokenEndpoints.endpoints.publicToken.select({ token: args.token })(state);

        if (!getResponse.data || !getResponse.data.eventSession) {
            return;
        }

        const successData: SuccessfulCheckIn = {
            sessionId: getResponse.data.eventSession.id,
            endDate: getResponse.data.eventSession.end,
            undoExpireDate: formatISO(addMinutes(new Date(), 5)), // hardcoded goodness
            undoToken: action.payload.data.undoToken,
            value: args.value,
        }

        publicTokenLocal.addSuccessfulCheckIn(successData);
        listenerApi.dispatch(setActiveSuccessful(successData));
    },
});

appListener.startListening({
    matcher: publicTokenEndpoints.endpoints.publicCheckInUndo.matchFulfilled,
    effect: (_, listenerApi) => {
        listenerApi.dispatch(setActiveSuccessful(undefined));
    },
});

appListener.startListening({
    actionCreator: clearPublicCheckInSuccessfulIds,
    effect: () => {
        publicTokenLocal.removeSuccessfulCheckIns();
    },
});
